/** Warm Horizon palette — use Tailwind classes in UI; these hex values are for charts, icons, and native APIs. */

/** BASIS Prague colors
  primary: #46b258
    - Užití: hlavni highlight, HL, bold body copy, pozadí, grafické elementy
  secondary: #c142aa
    - Užití: grafické elementy, pozadí, krátký text (např citáty), nikdy v body copy
  tertiary: #f5ea5f
    - Užití: pozad, grafické elementy, krátký text (pouze na tmavém pozadí), nikdy v body copy
*/

export const palette = {
    light: {
        primary: "#46b258",
        primaryHover: "#3F924D",
        primarySoft: "#EBFFEE",
        secondary: "#c142aa",
        secondaryHover: "#A13A8E",
        secondarySoft: "#FFEBFB",
        background: "#f7f8f7",
        surface: "#FFFFFF",
        text: "#1C1917",
        textMuted: "#78716C",
        border: "#E7E5E4",
        success: "#059669",
        successSecondary: "#E6F6EB",
        warning: "#D97706",
        error: "#DC2626",
        errorSecondary: "#FEF2F2",
        info: "#2563EB",
    },
    dark: {
        primary: "#68CA78",
        primaryHover: "#50B461",
        primarySoft: "#244229",
        secondary: "#D369C0",
        secondaryHover: "#BF4FAB",
        secondarySoft: "#42243D",
        background: "#1C1917",
        surface: "#292524",
        text: "#FAFAF8",
        textMuted: "#A8A29E",
        border: "#44403C",
        success: "#10B981",
        successSecondary: "#064E3B",
        warning: "#F59E0B",
        error: "#EF4444",
        errorSecondary: "#FEF2F2",
        info: "#3B82F6",
    },
} as const;

/** Semantic attendance colors — consistent in light and dark mode. */
export const attendance = {
    present: "#059669",
    absence: "#DC2626",
    tardiness: "#D97706",
    pending: "#5B4FCF",
    excused: "#0F766E",
} as const;

/** Login hero gradient (135deg). */
export const loginGradient = {
    from: "#46b258",
    to: "#c142aa",
    angle: "135deg",
} as const;
